import { authRequest } from './index.js'

export async function get_user(){
  let data
  // console.log("🚀 ~ file: child.js:39 ~ retrieve_children ~ authRequest:", authRequest)
  await authRequest.get(
    '/me'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    // console.log("🚀 ~ file: child.js:32 ~ retrieve_children ~ error:", error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function update_user(user){
  let data
  await authRequest.post(
    '/me',
    {user}
  ).then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    // console.log("🚀 ~ file: child.js:32 ~ retrieve_children ~ error:", error)
    data = {error: true, result: error.response.data}
  })
  return data
}